import React from "react";

function EmailIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.35205 7.71289L9.02166 9.29124C10.578 10.2114 11.2001 10.2114 12.7565 9.29124L15.4261 7.71289"
        stroke="#424242"
        strokeWidth="1.36111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.829 12.2277C1.88833 15.0094 1.91798 16.4003 2.94438 17.4305C3.97077 18.4609 5.39926 18.4967 8.25623 18.5685C10.017 18.6128 11.7605 18.6128 13.5213 18.5685C16.3783 18.4967 17.8068 18.4609 18.8331 17.4305C19.8596 16.4003 19.8893 15.0094 19.9485 12.2277C19.9677 11.3333 19.9677 10.4441 19.9485 9.5498C19.8893 6.76808 19.8596 5.37723 18.8331 4.34694C17.8068 3.31664 16.3783 3.28075 13.5213 3.20897C11.7605 3.16472 10.017 3.16472 8.25622 3.20896C5.39926 3.28073 3.97077 3.31662 2.94438 4.34693C1.91798 5.37723 1.88832 6.76807 1.829 9.54971C1.80993 10.4441 1.80993 11.3333 1.829 12.2277Z"
        stroke="#424242"
        strokeWidth="1.36111"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default EmailIcon;
